// extracted by mini-css-extract-plugin
export default {"indicatorContainer":"TankLevelIndicator_indicatorContainer__iOyxC","percentageContainer":"TankLevelIndicator_percentageContainer__ta+ol"};